import Skeleton from "@material-ui/lab/Skeleton";

export default function CardSkeleton() {
    return (
        <div className="CardSkeleton">
            <Skeleton variant="text" width='100%' height={18} />
            <Skeleton variant="text" width='100%' height={16} />
        </div>
    )
}